import { app } from './app';
import { location } from './location';
// import { workRequestAdd } from './workRequestAdd';
// import { workRequestDetails } from './workRequestDetails';
// import { user } from './editUser';
// import { settings } from './settings';
// import { workRequestListStore } from './workRequestList';
// import { motorPoolStore } from './motorPool';

// create
export { app };
export { location } from './location';
// export { workRequestAdd } from './workRequestAdd';
// export { workRequestDetails } from './workRequestDetails';
// export { workRequestListStore } from './workRequestList';
// export { motorPoolStore } from './motorPool';

export const root = {
  app,
  location,
  // user,
  // settings,
  // workRequestAdd,
  // workRequestDetails,
  // workRequestListStore,
  // motorPoolStore,
};

window.app = app;
window.root = root;
